import React from 'react';
import Link from 'next/link';

import * as ST from './styled';

interface ILink {
    text: string,
    link: string,
    dataTest?: string,
    onClick?: () => void,
    passHref?: boolean,
}

export const ListItemLi = ({ link, text, onClick, passHref, dataTest }: ILink) =>
    <ST.ListItemLi>
        <Link href={link} prefetch={false} passHref={passHref}>
            <ST.ListItemA href={link} onClick={onClick} data-test={dataTest}>{text}</ST.ListItemA>
        </Link>
    </ST.ListItemLi>;
